import { render, staticRenderFns } from "./ImsProfitLossAddTradeModal.vue?vue&type=template&id=0c3fbdfb&"
import script from "./ImsProfitLossAddTradeModal.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossAddTradeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports